import { useRef, useState, type DragEvent } from 'react'

import styles from './Dropzone.module.css'

const ACCEPT = '.xlsx,.xlsm,.csv,.txt'

export function Dropzone({ onFile, maxUploadMb }: { onFile: (file: File) => void; maxUploadMb: number }) {
  const input = useRef<HTMLInputElement>(null)
  const [over, setOver] = useState(false)

  function handleDrop(event: DragEvent) {
    event.preventDefault()
    setOver(false)
    const file = event.dataTransfer.files[0]
    if (file) onFile(file)
  }

  return (
    <>
      <button
        type="button"
        className={`${styles.zone} ${over ? styles.over : ''}`}
        onClick={() => input.current?.click()}
        onDragEnter={(event) => {
          event.preventDefault()
          setOver(true)
        }}
        onDragOver={(event) => event.preventDefault()}
        onDragLeave={() => setOver(false)}
        onDrop={handleDrop}
      >
        <div className={styles.icon}>
          <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M12 16V4m0 0L8 8m4-4l4 4" />
            <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2" />
          </svg>
        </div>
        <h3>Déposez le fichier ici</h3>
        <p>ou cliquez pour parcourir vos dossiers</p>
        <div className={styles.formats}>
          Colonnes nécessaires : EAN, prix d’achat, poids, quantité — {maxUploadMb} Mo maximum
        </div>
      </button>
      <input
        ref={input}
        type="file"
        accept={ACCEPT}
        hidden
        onChange={(event) => {
          const file = event.target.files?.[0]
          if (file) onFile(file)
          event.target.value = ''
        }}
      />
    </>
  )
}

export function FileBar({ name, size }: { name: string; size: number }) {
  return (
    <div className={styles.filebar}>
      <span className={styles.filename}>{name}</span>
      <span className={styles.filemeta}>· {(size / 1024).toFixed(0)} Ko</span>
    </div>
  )
}
